import { GpsTrackVehicleData, ParsedGpsTrackData } from './interfaces/GpsTrack.interface';

export class GpsTrackService {
    private baseUrl = 'https://app.gpstrack.in/api';
    private token = 'shreevarnatransport_atFRkWjY8IpqBWb8vj4eXEVHMWmDmjva';
    private email = 'shreevarnatransport@gmail.com';

    /**
     * Fetch vehicle data from GPS Track API
     * @returns Promise<GpsTrackVehicleData[] | null>
     */
    async fetchVehicleData(): Promise<GpsTrackVehicleData[] | null> {
        try {
            console.log(`🔗 Fetching GPS Track data from: ${this.baseUrl}/get_current_data`);

            const url = `${this.baseUrl}/get_current_data?token=${this.token}&email=${this.email}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                mode: 'cors',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data: GpsTrackVehicleData[] = await response.json();
            console.log('✅ GPS Track data fetched successfully:', data);
            console.log('🔍 GPS Track data structure:', {
                dataLength: data.length,
                firstVehicle: data[0] ? {
                    regNo: data[0].regNo,
                    latitude: data[0].latitude,
                    longitude: data[0].longitude,
                    vehicleStatus: data[0].vehicleStatus
                } : null
            });

            return data;
        } catch (error) {
            console.error('❌ Error fetching GPS Track data:', error);
            return null;
        }
    }

    /**
     * Parse GPS Track data into standardized format
     * @param data - Raw GPS Track API response
     * @returns ParsedGpsTrackData[]
     */
    parseVehicleData(data: GpsTrackVehicleData[]): ParsedGpsTrackData[] {
        return data.map(vehicle => {
            const parsedData: ParsedGpsTrackData = {
                vehicleNumber: vehicle.regNo || 'Unknown Vehicle',
                latitude: vehicle.latitude || 0,
                longitude: vehicle.longitude || 0,
                speed: vehicle.speed || 0,
                status: vehicle.vehicleStatus || 'UNKNOWN',
                battery: 0, // GPS Track doesn't provide battery info
                timestamp: vehicle.date || Date.now(),
                address: vehicle.address || 'Unknown Location',
                angle: vehicle.bearing || 0,
                acc: vehicle.ignitionStatus === 'ON',
                locationHistory: [], // GPS Track doesn't provide location history
                provider: 'gpstrack',
                rawData: vehicle
            };

            console.log('🔍 Parsed GPS Track data:', {
                vehicleNumber: parsedData.vehicleNumber,
                latitude: parsedData.latitude,
                longitude: parsedData.longitude,
                speed: parsedData.speed,
                status: parsedData.status,
                hasValidCoordinates: parsedData.latitude !== 0 && parsedData.longitude !== 0
            });

            return parsedData;
        });
    }

    /**
     * Validate GPS Track URL format
     * @param url - URL to validate
     * @returns boolean
     */
    isValidGpsTrackUrl(url: string): boolean {
        const gpsTrackPattern = /^https:\/\/(app\.)?gpstrack\.in\/api\/get_current_data/;
        return gpsTrackPattern.test(url);
    }

    /**
     * Extract vehicle identifier from GPS Track URL (if applicable)
     * @param url - GPS Track URL
     * @returns string | null
     */
    extractVehicleId(url: string): string | null {
        // GPS Track API doesn't use vehicle-specific URLs, returns all vehicles
        // But we can extract token/email for identification
        const tokenMatch = url.match(/token=([^&]+)/);
        const emailMatch = url.match(/email=([^&]+)/);

        if (tokenMatch && emailMatch) {
            return `${tokenMatch[1]}_${emailMatch[1]}`;
        }
        return null;
    }
}
